import styled from 'styled-components';

export const PageError = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 8% 0 5%;

  img {
    max-width: 100%;
  }
`;

export const Text = styled.h2`
  font-size: 20px;
  text-align: center;
  padding-top: 1%;
  text-transform: uppercase;
  font-family: 'Poppins', sans-serif!important;
`;